/** Schritt 5 „Ansprache“. */
const wizApproachDE = {
  wizApprTitle: 'Wie sprechen wir an?',
  wizApprSubtitle:
    'Diese Antworten bestimmen den Ablauf und den Ton der Nachrichten im nächsten Schritt.',
  wizApprKnown: 'Das weiß ich schon: {{info}} ({{name}})',
  wizApprAccountRecruiter: 'Konto: Recruiter, InMail-Guthaben',
  wizApprAccountSalesNav: 'Konto: Sales Navigator, InMail-Guthaben',
  wizApprAccountNormal: 'Konto: LinkedIn ohne erkennbares Premium',
  wizApprRecruitsForTitle: 'Rekrutiert ihr für das eigene Unternehmen oder als Dienstleister?',
  wizApprRecruitsOwn: 'Eigenes Unternehmen',
  wizApprRecruitsClients: 'Als Dienstleister für Kunden',
  wizApprAudienceTitle: 'Wen sprichst du in dieser Kampagne an?',
  wizApprAudienceNew: 'Nur neue Kontakte',
  wizApprAudienceNewDesc: 'Kontaktanfrage zuerst, InMail als Fallback',
  wizApprAudienceExisting: 'Nur bestehende Kontakte',
  wizApprAudienceExistingDesc: 'Direkt per Nachricht, keine InMails',
  wizApprAudienceBoth: 'Beides',
  wizApprAudienceBothDesc: 'Weiche pro Kontakt am Anfang',
  wizApprNoteTitle: 'Kontaktanfrage',
  wizApprNoteWith: 'Mit Nachricht',
  wizApprNoteWithDesc: 'Kurze Notiz direkt in der Anfrage',
  wizApprNoteWithout: 'Ohne Nachricht',
  wizApprNoteWithoutDesc: 'Erste Nachricht erst nach der Annahme',
  wizApprInmailTitle: 'Wenn die Kontaktanfrage nicht angenommen wird',
  wizApprInmailWith: 'Mit InMail nachfassen',
  wizApprInmailWithDesc: 'Eine InMail, danach wird die Anfrage zurückgezogen',
  wizApprInmailWithout: 'Ohne InMail',
  wizApprInmailWithoutDesc: 'Die Anfrage wird zurückgezogen, das InMail-Guthaben bleibt',
  wizApprReferralTitle: 'Am Ende nach einer Empfehlung fragen, falls kein Eigeninteresse?',
  wizApprReferralYes: 'Ja, mit Empfehlungs-Prämie',
  wizApprReferralYesDesc: 'Nenn die Höhe, sie steht dann in der Nachricht.',
  wizApprReferralNo: 'Nein',
  wizApprReferralNoDesc: 'Der Ablauf endet mit der Breakup-Nachricht.',
  wizApprCreditTitle: 'Hat dieses LinkedIn-Konto InMail-Guthaben (Premium)?',
  wizApprCreditYes: 'Ja, InMail-Guthaben vorhanden',
  wizApprCreditYesDesc: 'Eine InMail als Fallback, wenn die Anfrage nicht angenommen wird',
  wizApprCreditNo: 'Nein',
  wizApprCreditNoDesc: 'Nach dem Wartefenster wird die Anfrage zurückgezogen',
  wizApprBonusLabel: 'Prämie, z. B. 500 €',
  wizApprLanguageTitle: 'Sprache der Nachrichten',
  wizApprLangPrimary: 'Primäre Sprache',
  wizApprLangSecondary: 'Sekundäre Sprache (optional)',
  wizApprLangDe: 'Deutsch',
  wizApprLangEn: 'Englisch',
  wizApprLangAuto: 'Sprache des Profils erkennen',
  wizApprLangNone: 'Keine',
  wizApprLangSecondaryHint:
    'Wenn leer, werden alle Nachrichten in der primären Sprache versendet. Wird hier eine Sprache gewählt, erhalten Kontakte, deren Profilsprache nicht der primären entspricht, Nachrichten in dieser Fallback-Sprache.',
  wizApprEmojis: 'Emojis erlauben',
  wizApprSwissS: '„ß“ zu „ss“ umwandeln',
  wizApprCalendar: 'Kalenderlink verwenden',
  wizApprCalendarDesc:
    'Wird bei konkreten Terminvorschlägen und in der Breakup-Nachricht als niedrigschwellige Option eingebaut.',
  wizApprCalendarPlaceholder: 'https://calendly.com/dein-name/15min',
  wizApprAutoReply: 'Antworten automatisch beantworten',
  wizApprAutoReplyDesc:
    'Die KI beantwortet eingehende Antworten der Kontakte anhand von Ziel und Fällen. Aus: Sobald jemand antwortet, übernimmst du.',
  wizApprAutoReplyNoCalendar:
    'Hinweis: Ohne Kalenderlink bleibt der Meeting-Link-Platzhalter in den Antworten leer.',
  wizApprAutoReplyShow: 'Einstellungen für automatische Antworten anzeigen',
  wizApprAutoReplyHide: 'Einstellungen ausblenden',
  wizApprFormalityTitle: 'Wie sprichst du die Kandidaten an?',
  wizApprFormalSie: 'Sie',
  wizApprFormalSieDesc: 'Förmliche Ansprache (Standard)',
  wizApprFormalDu: 'Du',
  wizApprFormalDuDesc: 'Persönliche Ansprache',
  wizApprPlaceholdersTitle: 'Eigene Platzhalter',
  wizApprPlaceholdersHint:
    'Eigene Angaben wie Benefits, Gehalt oder Home Office (ein Schlüssel + Wert). SAIA baut jeden Platzhalter automatisch in passende Nachrichten ein. In den automatischen Antworten kannst du sie ebenfalls einsetzen, z. B. {{example}}. Der Kalenderlink oben steht als {{link}} bereit.',
  wizApprPlaceholderValueHint:
    'Trage hier ergänzende Informationen zu deiner Suche ein, welche nicht in der Stellenbeschreibung vorkommen, damit sie in den Nachrichten durch SAIA genutzt werden können.',
  wizApprPlaceholderKeyInvalid: 'Nutze Buchstaben, Ziffern und Unterstriche, Wörter getrennt durch Leerzeichen (z. B. Home Office).',
  wizApprPlaceholderKeyUsed: 'Diesen Schlüssel gibt es schon. Pro Platzhalter ist genau ein Schlüssel möglich, jeder nur einmal.',
};
export default wizApproachDE;
